import {useState} from "react";

/**
 * Creates state for fetching and two methods: start and stop.
 * @returns [fetching: boolean, startFetching, stopFetching]
 * @author Kacper Faber
 * @since 0.1.7
 */
function useFetching(init: boolean): [boolean, () => void, () => void] {
    const [fetching, setFetching] = useState(init);

    const [startFetching, stopFetching] = [
        () => setFetching(true),
        () => setFetching(false),
    ];

    return [fetching, startFetching, stopFetching];
}

// noinspection JSUnusedGlobalSymbols
export default useFetching;